import React from "react";
import LogoSpinner from "./ui/LogoSpinner";

/**
 * Suspense fallback shown while a lazy route chunk downloads.
 *
 * Two variants:
 * - default: fills the casino layout's content area, keeping the persistent
 *   sidebar/header visible around it
 * - fullScreen: for routes rendered outside PersistentCasinoLayout
 *   (admin, affiliate, auth, legal)
 */
const RouteFallback = ({ fullScreen = false }) => (
  <div
    className={
      fullScreen
        ? "min-h-screen bg-background flex items-center justify-center"
        : "flex items-center justify-center min-h-[50vh] py-24"
    }
  >
    <LogoSpinner size="large" />
  </div>
);

export default RouteFallback;
